import { GETAiNews } from '@fe-news/api/ai';

// type
import type { Response } from '@fe-news/constants/api';
import { AiArticleType, GETv1AiArticlesReturnResponse, DEFAULT_AI_CONTENT } from '@fe-news/constants/ai/type';

// 搜尋 AI 摘要新聞

export const fetchAiNews = async ({
  type
}: {
  type: AiArticleType;
}): Promise<Response<GETv1AiArticlesReturnResponse>> => {
  try {
    const response = await GETAiNews({ type });

    return { data: response, isError: false, message: '成功' };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.error(`[ACTION ERROR]: fetchAiNews ${type}`, error);
    return {
      isError: true,
      data: DEFAULT_AI_CONTENT,
      message: `[ACTION ERROR]: fetchAiNews ${type}: ${errorMessage}`
    };
  }
};
